'use client';

import React, { useState, useEffect } from 'react';
import { AlertDialog } from './AlertDialog';
import alertService from '@/services/alertService';

/**
 * Global Alert Dialog Provider
 * Place this in your root layout to enable alerts from anywhere in the app
 */
export function GlobalAlertDialog() {
  const [alertState, setAlertState] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info'
  });

  useEffect(() => { 
    const unsubscribe = alertService.subscribe((alert) => { 
      setAlertState(alert);
    });

    return () => { 
      unsubscribe();
    };
  }, []);

  const handleClose = () => {
    setAlertState(prev => ({ ...prev, isOpen: false }));
  };

  return (
    <AlertDialog
      isOpen={alertState.isOpen}
      onClose={handleClose}
      title={alertState.title}
      message={alertState.message}
      type={alertState.type}
    />
  );
}
